import ky from 'ky'

// In monolith mode, frontend is served from same origin as API
const host = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8080'
const api = '/api/v1/'
const appApi = '/api/v1/app/'

// ========== AUTH ==========
function login({ username, password }) {
  const url = host + api + 'auth'
  return ky.post(url, {
    json: { username, password }
  }).text()
}

function validate(token) {
  const url = host + api + 'auth/validate'
  return ky.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

// ========== PLANNING ==========
function getPlanning({ start, end, seqpers, token }) {
  const url = host + appApi + 'planning'
  return ky.get(url, {
    searchParams: { start, end, seqpers },
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function updatePlanning({ seqplan, update, token }) {
  const url = host + appApi + 'planning/' + seqplan
  return ky.patch(url, {
    json: update,
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

// ========== USER ==========
function getUser({ seqpers, token }) {
  const url = host + appApi + 'user/' + seqpers
  return ky.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

// ========== MASTER DATA ==========
function getExtra({ token }) {
  const url = host + appApi + 'extra'
  return ky.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function getExtraPositions({ token }) {
  const url = host + appApi + 'extra-positions'
  return ky.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function getPositions({ token }) {
  const url = host + appApi + 'positions'
  return ky.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

// ========== WORK PROGRESS ==========
function getWorkProgress({ seqwerk, token }) {
  const url = host + appApi + 'work-progress/' + seqwerk
  return ky.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function addWorkProgress({ seqpers, seqwerk, seqwerkdet, amount, idTWerkDetail, createdBy, token }) {
  const url = host + appApi + 'work-progress'
  return ky.post(url, {
    json: { seqpers, seqwerk, seqwerkdet, amount, idTWerkDetail, createdBy },
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function deleteWorkProgress({ id, token }) {
  const url = host + appApi + 'work-progress/' + id
  return ky.delete(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

// ========== WORK DETAIL ==========
function createWork({ work, token }) {
  const url = host + appApi + 'work-detail'
  work.change_by_app = 1
  return ky.post(url, {
    json: work,
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function updateWork({ id, update, token }) {
  const url = host + appApi + 'work-detail/' + id
  update.change_by_app = 1
  return ky.patch(url, {
    json: update,
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function deleteWork({ id, token }) {
  const url = host + appApi + 'work-detail/' + id
  return ky.delete(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

// ========== WORK EXTRA ==========
function createWorkExtra({ extra, token }) {
  const url = host + appApi + 'work-extra'
  return ky.post(url, {
    json: extra,
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function deleteWorkExtra({ id, token }) {
  const url = host + appApi + 'work-extra/' + id
  return ky.delete(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

// ========== OTHER COSTS ==========
function createWorkOtherCosts({ workOtherCosts, token }) {
  const url = host + appApi + 'other-costs'
  return ky.post(url, {
    json: workOtherCosts,
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function updateWorkOtherCosts({ id, update, token }) {
  const url = host + appApi + 'other-costs/' + id
  return ky.patch(url, {
    json: update,
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function deleteWorkOtherCosts({ id, token }) {
  const url = host + appApi + 'other-costs/' + id
  return ky.delete(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

// ========== COMMENTS ==========
function createComment({ comment, token }) {
  const url = host + appApi + 'comments'
  return ky.post(url, {
    json: comment,
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function updateComment({ seqopm, update, token }) {
  const url = host + appApi + 'comments/' + seqopm
  return ky.patch(url, {
    json: update,
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function deleteComment({ seqopm, token }) {
  const url = host + appApi + 'comments/' + seqopm
  return ky.delete(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

// ========== FILES ==========
// File upload uses the separate /file route (not /app)
function uploadFile({ file, filename, seqwerk, seqopm, seqpers, isSignature, token }) {
  const url = host + api + 'file'
  const formData = new FormData()
  formData.append('seqwerk', seqwerk)
  formData.append('seqpers', seqpers)
  formData.append('file', file, filename)
  if (seqopm) {
    formData.append('seqopm', seqopm)
    formData.append('bij_opmerking', true)
  }
  if (isSignature) {
    formData.append('is_handtekening', true)
  }
  return ky.post(url, {
    body: formData,
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function updateFile({ seqafb, update, token }) {
  const url = host + appApi + 'files/' + seqafb
  return ky.patch(url, {
    json: update,
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

function getFile({ seqafb, thumbnail, token }) {
  const url = host + api + 'file/' + seqafb + (thumbnail ? '/thumbnail' : '')
  return ky.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  })
}

function deleteFile({ seqafb, token }) {
  const url = host + appApi + 'files/' + seqafb
  return ky.delete(url, {
    headers: { Authorization: `Bearer ${token}` }
  }).json()
}

export {
  login,
  validate,
  getPlanning,
  updatePlanning,
  getUser,
  getExtra,
  getExtraPositions,
  getPositions,
  addWorkProgress,
  getWorkProgress,
  deleteWorkProgress,
  createWork,
  updateWork,
  deleteWork,
  createWorkExtra,
  deleteWorkExtra,
  createWorkOtherCosts,
  updateWorkOtherCosts,
  deleteWorkOtherCosts,
  createComment,
  updateComment,
  deleteComment,
  uploadFile,
  updateFile,
  getFile,
  deleteFile
}
